import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as $ from 'jquery';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'comp-video',
  templateUrl: './comp-video.component.html',
  styleUrls: ['./comp-video.component.css']
})
export class CompVideoComponent implements OnInit {


  constructor() { }

  ngOnInit(): void 
  {
  
  }




  closeVideo(video_container : HTMLElement) {
    
    
    // remove video container object
    video_container.remove();

  }



}
